import {
  DIRECTION_ABOVE,
  DIRECTION_BELOW,
  DIRECTION_BOTTOM,
  DIRECTION_TOP,
  SIZE_LG,
  SIZE_MD,
} from '../../config/constants';

export const MULTISELECT_SIZES = [
  SIZE_MD,
  SIZE_LG,
];

// eslint-disable-next-line import/prefer-default-export
export const MULTISELECT_DIRECTIONS = [
  DIRECTION_ABOVE,
  DIRECTION_TOP,
  DIRECTION_BELOW,
  DIRECTION_BOTTOM,
];
